import { IntlMessageFormat } from "intl-messageformat";
import { translatedLocales } from "../locale/locale";
import { TranslationValue } from "../types";

export type Translations = { [messageId: string]: TranslationValue };

export function loadTranslations(locale: string = "en-US"): Translations {
  const translations = translatedLocales[locale];
  if (translations) {
    return translations as Translations;
  } else {
    console.warn(`${locale} not found. Falling back to en-US.`);
    return translatedLocales["en-US"] as Translations;
  }
}

export const createFormatter = async (locale: string = "en-US") => {
  const messages = await loadTranslations(locale);
  const fallbackMessages =
    locale !== "en-US" ? await loadTranslations("en-US") : messages;

  return (
    messageId: string,
    values?: Record<string, string | number | boolean | null | undefined>,
  ): string | undefined => {
    let message = messages[messageId];

    if (!message) {
      console.warn(
        `${messageId} not found in locale "${locale}", falling back to "en-US".`,
      );
      message = fallbackMessages[messageId];
    }

    if (!message) {
      console.error(`${messageId} not found in any locale.`);
      return undefined;
    }

    const formatter = new IntlMessageFormat(message as string, locale);
    const formattedMessage = formatter.format(values);
    return typeof formattedMessage === "string" ? formattedMessage : undefined;
  };
};
